var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recycle-svgrepo-com 1",
    clipPath: "url(#clip0_11530_12527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.576 13.8672C19.976 13.8672 19.576 13.4672 19.576 12.8672C19.576 8.96719 16.476 5.86719 12.576 5.86719C10.676 5.86719 8.97598 6.56719 7.57598 7.86719C7.27598 8.26719 6.57598 8.26719 6.17598 7.86719C5.77598 7.46719 5.77598 6.86719 6.17598 6.46719C7.87598 4.76719 10.176 3.86719 12.576 3.86719C17.576 3.86719 21.576 7.86719 21.576 12.8672C21.576 13.4672 21.176 13.8672 20.576 13.8672Z",
    fill: "#E5E5E5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5762 21.8672C7.57617 21.8672 3.57617 17.8672 3.57617 12.8672C3.57617 12.2672 3.97617 11.8672 4.57617 11.8672C5.17617 11.8672 5.57617 12.2672 5.57617 12.8672C5.57617 16.7672 8.67617 19.8672 12.5762 19.8672C14.4762 19.8672 16.1762 19.1672 17.5762 17.8672C17.9762 17.4672 18.5762 17.4672 18.9762 17.8672C19.3762 18.2672 19.3762 18.8672 18.9762 19.2672C17.2762 20.9672 14.9762 21.8672 12.5762 21.8672Z",
    fill: "#E5E5E5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.5756 13.8651C20.3756 13.8651 20.1756 13.7651 19.9756 13.6651L16.5756 11.1651C16.1756 10.8651 16.0756 10.1651 16.3756 9.76506C16.6756 9.36506 17.3756 9.26506 17.7756 9.56506L21.1756 12.0651C21.5756 12.3651 21.6756 13.0651 21.3756 13.4651C21.1756 13.7651 20.8756 13.8651 20.5756 13.8651Z",
    fill: "#E5E5E5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.576 13.8666C20.376 13.8666 20.176 13.7666 19.976 13.6666C19.576 13.3666 19.476 12.6666 19.776 12.2666L22.276 8.86662C22.576 8.46662 23.276 8.36662 23.676 8.66662C24.076 8.96662 24.176 9.66662 23.876 10.0666L21.376 13.4666C21.176 13.7666 20.876 13.8666 20.576 13.8666Z",
    fill: "#E5E5E5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.976 16.3651C7.776 16.3651 7.576 16.2651 7.376 16.1651L3.976 13.6651C3.576 13.3651 3.476 12.6651 3.776 12.2651C4.076 11.8651 4.676 11.7651 5.176 12.0651L8.576 14.5651C8.976 14.8651 9.076 15.5651 8.776 15.9651C8.576 16.2651 8.276 16.3651 7.976 16.3651Z",
    fill: "#E5E5E5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.076 17.2651C1.876 17.2651 1.676 17.1651 1.476 17.0651C1.076 16.7651 0.975996 16.0651 1.276 15.6651L3.776 12.2651C4.076 11.8651 4.676 11.7651 5.176 12.0651C5.576 12.3651 5.676 13.0651 5.376 13.4651L2.876 16.8651C2.676 17.1651 2.376 17.2651 2.076 17.2651Z",
    fill: "#E5E5E5"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11530_12527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.576172 0.867188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshLight);
export default __webpack_public_path__ + "static/media/refresh_light.ddfc764caca990ef81451f49330e55f7.svg";
export { ForwardRef as ReactComponent };